<template>
	<div>
		<Header />
		<Carousel v-model="value" loop :height="400" arrow="never" dots="none">
			<CarouselItem>
				<div class="banner"
					:style="{'background': 'url('+require('@/assets/img/tableEntryService/designBanner.jpg')+') center center no-repeat'}">
					<div>
						<p class="pageType_">数据产品设计工具</p>
						<p>
							基于Ai算法、大语言模型、行业数据产品案例库结合企业行业特性、主营业务及数据资源描述，构建智能分析平台为企业输出高价值数据产品。
						</p>
						<router-link tag="button" class="buttonFill" to="/dataProductDesign">立即设计数据产品</router-link>
					</div>
				</div>
			</CarouselItem>
		</Carousel>

		<div class="mainContent">
			<div>
				<p class="moduleTitle">产品介绍</p>
				<div class="introduce">
					<img src="../../assets/img/tableEntryService/introduceImg.png" alt="产品介绍" />
					<div>
						<ul>
							<li>
								<img src="../../assets/img/tableEntryService/introduceIcon1.png" alt="算法" />
								<p>Ai 算法</p>
								<p>深度训练的Ai算法矩阵</p>
							</li>
							<li>
								<img src="../../assets/img/tableEntryService/introduceIcon2.png" alt="亿万级" />
								<p>万亿级</p>
								<p>参数大语言模型</p>
							</li>
							<li>
								<img src="../../assets/img/tableEntryService/introduceIcon3.png" alt="13000+" />
								<p>13000+</p>
								<p>行业标杆数据产品案例库</p>
							</li>
						</ul>

						<div>
							<p>
								依托深度训练的 Ai算法矩阵与万亿级参数大语言模型，融合13000 + 行业标杆数据产品案例库，这款智能设计工具以企业基因解码为核心 ——
								精准锚定行业特性、主营业务逻辑与数据资源禀赋，一键生成高价值数据产品。</p>
							<p>从数据产品规划、应用场景、当地政策补贴到交易所合规上架路径规划，全流程智能推演；</p>
							<p>
								内置动态风险预警，八维智能风险协防矩阵从交易风险、操纵风险、估值风险、确权风险、技术风险、财务风险、监管风险、市场风险等，让企业数据资产快速实现商业闭环。
							</p>
						</div>

					</div>
				</div>
			</div>

			<div>
				<p class="moduleTitle">产品特点</p>
				<ul class="productFeature">
					<li>
						<img src="../../assets/img/tableEntryService/feature1.png" alt="企业基因级智能设计" />
						<i></i>
						<div class="featureItem"
							:style="{'background':method.getHexColor(hexToRgb($store.state.user.subjectColor.mainColor, '0.05'))}">
							<p class="title">企业基因级智能设计</p>
							<span>基于深度训练的大模型（万亿级参数）解码行业特性与业务逻辑</span>
							<span>融合13000+标杆案例库实现精准框架匹配</span>
							<span>一键智能生成高价值、符合企业自身特点的数据产品</span>
						</div>
					</li>
					<li>
						<img src="../../assets/img/tableEntryService/feature2.png" alt="全链路政策穿透推演" />
						<i></i>
						<div class="featureItem"
							:style="{'background':method.getHexColor(hexToRgb($store.state.user.subjectColor.mainColor, '0.05'))}">
							<p class="title">全链路政策穿透推演</p>
							<span>不仅规划产品本身，还智能推演其应用场景</span>
							<span>动态解析当地产业政策与补贴规则</span>
							<span>智能规划交易所上架合规路径</span>
						</div>
					</li>
					<li>
						<img src="../../assets/img/tableEntryService/feature3.png" alt="八维智能风险协防矩阵" />
						<i></i>
						<div class="featureItem"
							:style="{'background':method.getHexColor(hexToRgb($store.state.user.subjectColor.mainColor, '0.05'))}">
							<p class="title">八维智能风险协防矩阵</p>
							<span>全面覆盖数据资产化及交易过程中的关键风险点（包括交易、操纵、估值、确权、技术、财务、监管、市场风险）</span>
							<span>闭环风控：风险特征实时注入产品设计流</span>
							<span>防御纵深：覆盖数据产品全生命周期风险场景</span>
						</div>
					</li>
				</ul>
			</div>

			<div>
				<p class="moduleTitle">核心功能</p>
				<div class="coreFunction">
					<ul>
						<li :style="{'background':method.getHexColor(hexToRgb($store.state.user.subjectColor.mainColor, '0.05'))}">
							<div>
								<p>企业基因智能解码</p>
								<p>深度分析企业所处行业特性、核心业务逻辑、独特数据资产禀赋与潜在价值点，形成数据产品化的基础画像。</p>
							</div>
						</li>
						<li :style="{'background':method.getHexColor(hexToRgb($store.state.user.subjectColor.mainColor, '0.05'))}">
							<div>
								<p>高价值数据产品智能生成</p>
								<p>基于“企业基因解码”结果，自动生成符合企业实际的潜在的高价值数据产品及应用场景，融合13000+行业标杆数据产品案例库进行模式匹配与创新启发。</p>
							</div>
						</li>
						<li :style="{'background':method.getHexColor(hexToRgb($store.state.user.subjectColor.mainColor, '0.05'))}">
							<div>
								<p>全流程智能推演与路径规划</p>
								<p>识别并匹配相关的国家、地方及行业数据要素相关政策与补贴申请路径建议，规划数据产品在目标数据交易所（如数商所、数交所）合规上架的关键步骤、所需材料及合规性要求。品化的基础画像。</p>
							</div>
						</li>
					</ul>
					<div>
						<img src="../../assets/img/tableEntryService/kernel.png" alt="核心功能" />
					</div>
				</div>
			</div>


		</div>

		<SignUp />
		<Footer />
	</div>
</template>

<script>
	import Header from '../../common/header/flow_header.vue'
	import Footer from '../../common/footer.vue'
	import publicMethod from '../publicMethod'
	import SignUp from '@/components/signUp/index.vue'
	import tsconfig from '@/assets/js/tsconfig.json';

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			SignUp
		},
		data() {
			return {
				url: this.domain.testUrl + this.domain.valuationProject,
				value: 0


			}
		},
		mounted() {

		},
		methods: {


		}

	}
</script>

<style scoped lang="less">
	.pageType_ {
		font-size: 36px;
		color: var(--mainColor);
		font-weight: bold;
		padding-bottom: 10px;
		margin-bottom: 25px;
		position: relative;
	}

	.pageType_::after {
		content: '';
		display: block;
		width: 310px;
		height: 2px;
		background: var(--mainColor);
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.pageType_+p {
		width: 680px;
		font-size: 20px;
		color: #282828;
	}

	.banner .buttonFill {
		border-radius: 23px;
		margin-top: 40px;
	}

	.introduce {
		display: flex;
		justify-content: space-between;

		>div {
			width: 621px;

			>ul {
				width: 680px;
				display: flex;
				justify-content: space-between;
				background: var(--mainColor);
				padding: 15px 20px 10px;
				border-radius: 8px;
				box-shadow: 0px 0px 13px 0px rgba(86, 136, 205, 0.23);
				position: relative;
				top: 20px;
				left: -60px;
				margin-bottom: 40px;

				li {
					position: relative;

					p:nth-of-type(1) {
						font-weight: bold;
						font-size: 20px;
						color: #FFFFFF;
					}

					p:nth-of-type(2) {
						font-size: 14px;
						color: #FFFFFF;
					}
				}

				li:not(:last-child)::after {
					content: '';
					display: block;
					width: 36px;
					height: 36px;
					background: url(../../assets/img/tableEntryService/plusSign.png) center center no-repeat;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 112%;
				}
			}

			>ul+div {
				p {
					font-size: 14px;
					color: #282828;
					line-height: 24px;
				}

				p:not(:last-child) {
					margin-bottom: 15px;
				}
			}
		}
	}

	.productFeature {
		display: flex;
		justify-content: space-between;

		li {
			width: 387px;
			height: 400px;
			position: relative;

			img {
				display: block;
				margin: 0 auto;
				position: relative;
				z-index: 4;
			}

			i {
				content: '';
				display: block;
				width: 100%;
				height: 100px;
				background: var(--mainColor);
				border-radius: 10px 10px 0 0;
				position: absolute;
				top: 85px;

			}

			.featureItem {
				width: 100%;
				height: 298px;
				box-shadow: 2px 2px 13px 0px rgba(6, 76, 156, 0.23);
				border-radius: 10px;
				position: absolute;
				top: 92px;
				z-index: 3;

				>.title {
					font-weight: bold;
					font-size: 20px;
					color: var(--mainColor);
					text-align: center;
					margin-top: 108px;
					margin-bottom: 10px;
				}

				>span {
					width: 313px;
					display: block;
					font-size: 14px;
					color: #282828;
					line-height: 24px;
					margin: 0 auto;
					padding-left: 16px;
					text-align: justify;
					position: relative;
				}

				>span:before {
					content: '';
					display: block;
					width: 7px;
					height: 7px;
					background: var(--mainColor);
					transform: rotate(136deg);
					position: absolute;
					left: 0;
					top: 7px;
				}
			}
		}
	}

	.coreFunction {
		display: flex;

		>div {
			width: 583px;
			height: 455px;
			background: var(--mainColor);
			padding: 20px;
		}

		ul {
			li {
				width: 617px;
				height: 125px;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				padding: 0 30px;
				margin-top: 20px;
				
				p:first-child{
					font-weight: bold;
					font-size: 20px;
					color: var(--mainColor);
					margin-bottom: 5px;
				}
				
				p:last-child{
					font-size: 14px;
					color: #282828;
					line-height: 24px;
					text-align: justify;
				}
			}

			
		}
	}
</style>